export default __webpack_public_path__ + "static/RunLeft7-5092faf1c675dd56813840fcec90d4c4.mp3";